import images from '../../constants/images';
export const workSet = [
    {
      id: 1,
      name: 'Vue.js_App',
      img: images.pass,
      description: "This application generate a random password by providing the number of character(digit)",
      url: "https://passworator.netlify.app",
      github:'https://github.com/shivansh-sagar/PasswordGenerator',
      tag: 'PasswordGenerator'
    },
    {
      id: 2,
      name: 'React_App',
      img: images.bot,
      description: "This is chatbot made for LocalShopIndia",
      url: "https://lsi-bot.netlify.app",
      github:'https://github.com/shivansh-sagar/LSI_bot',
      tag: 'LSI-Bot'
    },
    {
        id: 3,
        name: 'Vue.js_App',
        img: images.dc_heroes,
        description: "This application perform all the CRED operation using only frontend",
        url: "https://dc-heroes.netlify.app/",
        github:'https://github.com/shivansh-sagar/DC-heroes-list',
        tag: 'DC-heroes-list'
      },
      {
        id: 4,
        name: 'Reactjs_App',
        img: images.texteditor,
        description: "Text-form is one stop application to perform various manipulation on your text",
        url: "https://dc-heroes.netlify.app/",
        github:'https://github.com/shivansh-sagar/Textform',
        tag: 'Text-fotm'
      },
    
  ];

